import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import CheckboxTableCell from 'components/common/table/CheckboxTableCell';
import { StyledTable, StyledHeaderCell } from 'components/common/Styles';
import { TableBody, TableHead, Grid, TableRow } from '@mui/material';
import { StyledTableBodyCell } from 'components/common/Styles';
import { useTranslation } from 'react-i18next';
import { valueOrDefault } from 'utils/functions';
import { get, set, sequence } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { ThemedWrapper } from 'components/common/SurfaceStyles';
import { getErrors } from '@totalsoft/pure-validations-react';

const BaseTypesContainer = ({ partnerTypeId, lens, validation }) => {
  const [t] = useTranslation();

  const validationErrors = useMemo(() => {
    if (validation?.baseTypes === undefined) {
      return null;
    }
    return getErrors(validation.baseTypes);
  }, [validation]);

  return (
    <Fragment>
      {validationErrors && (
        <Grid item container xs={4} sx={{ mt: 2 }}>
          <ThemedWrapper color='error'>{validationErrors}</ThemedWrapper>
        </Grid>
      )}
      <StyledTable sx={{ width: '40%' }}>
        <TableHead>
          <TableRow>
            <StyledHeaderCell></StyledHeaderCell>
            <StyledHeaderCell>{t('PartnerType.Details.PartnerBaseType.Code')}</StyledHeaderCell>
            <StyledHeaderCell>{t('PartnerType.Details.PartnerBaseType.Name')}</StyledHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(lens.length |> get) > 0 &&
            (lens |> sequence).map(baseTypeLens => (
              <TableRow key={crypto.randomUUID()}>
                <CheckboxTableCell
                  checked={baseTypeLens.isSelected |> get |> valueOrDefault(false)}
                  onChange={baseTypeLens.isSelected |> set |> onCheckBoxChange}
                  disabled={Boolean(partnerTypeId)}
                />
                <StyledTableBodyCell> {baseTypeLens.code |> get} </StyledTableBodyCell>
                <StyledTableBodyCell> {baseTypeLens.name |> get} </StyledTableBodyCell>
              </TableRow>
            ))}
        </TableBody>
      </StyledTable>
    </Fragment>
  );
};

BaseTypesContainer.propTypes = {
  partnerTypeId: PropTypes.number,
  lens: PropTypes.object.isRequired,
  validation: PropTypes.object
};

export default BaseTypesContainer;
